export default __webpack_public_path__ + "static/media/no-image-available.b28724e1.png";